import logo from "../assets/images/logo.png";
import emblem from "../assets/images/emblem.png";
import emblemMenu from "../assets/images/emblem-menu.png";
import person from "../assets/images/person.png";
import QR from "../assets/images/QR.png";
import QR_dark from "../assets/images/qr_darkmode.png";

export default { logo, emblem, emblemMenu, person, QR, QR_dark };
